const SET_SNACKBAR = 'pessoalize-web/snackbar/SET_SNACKBAR';

const initialState = {
  snackbarOpen: false,
  snackbarType: 'success',
  snackbarMessage: '',
};

export default (state = initialState, action) => {
  const { snackbarOpen, snackbarMessage, snackbarType } = action;
  switch (action.type) {
    case SET_SNACKBAR:
      return {
        ...state,
        snackbarOpen,
        snackbarType,
        snackbarMessage,
      };
    default:
      return state;
  }
};

export const setSnackbar = (
  snackbarOpen,
  snackbarType = 'success',
  snackbarMessage = '',
) => ({
  type: SET_SNACKBAR,
  snackbarOpen,
  snackbarType,
  snackbarMessage,
});
